import { Link } from 'react-router-dom';
import { TicketImporter } from 'features/TicketImporter';
import { ROUTES } from 'features/routes';
import { useAppSelector } from 'store/hooks';

const TicketImporterPage = (): JSX.Element => {
	const { loggedUser } = useAppSelector((state) => state.auth);

	const partnerId = loggedUser?.currentPartner?.ID || Number(localStorage.getItem('currentPartnerId')) || 0;
	if (!partnerId) {
		return (
			<div style={{ padding: '48px 40px', maxWidth: 720, margin: '0 auto' }}>
				<h1 style={{ fontSize: 24, marginBottom: 8 }}>Select a partner first</h1>
				<p style={{ color: '#6b7280', fontSize: 14, marginBottom: 24 }}>
					The ticket importer needs a partner context — all imports are scoped to the selected partner&apos;s events and
					ticket types. Pick a partner to continue.
				</p>
				<Link to={ROUTES.SWITCH_TEAM_PATH} style={{ color: '#6366f1', fontWeight: 500 }}>
					Go to Switch Team →
				</Link>
			</div>
		);
	}

	return <TicketImporter />;
};

export default TicketImporterPage;
